import styles from "./carousel.module.css"
import {useEffect} from "react";

export default function Carousel({children, displayItems, id}){

    useEffect(() =>{
        initSlider();
    }, [])
    function initSlider() {
        const slider = document.getElementById(id);
        const slides = slider.children;
        const button = document.getElementsByClassName(styles.button);
        
        

        let current = 1;
        let prev = 0;
        let next = 2;

        slides[current].classList.add(styles.active);
        slides[prev].classList.add(styles.prev);
        slides[next].classList.add(styles.next);
        

        for (let i = 0; i < button.length; i++) {
            button[i].addEventListener("click", () => i == 0 ? gotoPrev() : gotoNext());
        }

        const gotoPrev = () => current > 0 ? gotoNum(current - 1) : gotoNum(slides.length - 1);

        const gotoNext = () => current < slider.childElementCount - 1 ? gotoNum(current + 1) : gotoNum(0);

        const gotoNum = number => {
            current = number;
            prev = current - 1;
            next = current + 1;

            for (let i = 0; i < slides.length; i++) {
                slides[i].classList.remove(styles.active);
                slides[i].classList.remove(styles.prev);
                slides[i].classList.remove(styles.next);
            }

            if (next == slider.childElementCount) {
                next = 0;
            }

            if (prev == -1) {
                prev = slider.childElementCount - 1;
            }

            slides[current].classList.add(styles.active);
            slides[prev].classList.add(styles.prev);
            slides[next].classList.add(styles.next);
        }
    }


    return (
        <div className="horizontal mobile">
            <div className={`${styles.button} ${styles.left}`}><p className="marker standalone black"></p></div>
            <div id={id} className={styles.items}>
                {children}
            </div>
            <div className={`${styles.button}`}><p className="marker standalone black"></p></div>
        </div>
    );
}
